import { createApp } from "vue";
import "primeicons/primeicons.css";
import { defineCustomElements as defineDashButton } from "dash-button-web/loader";
import { defineCustomElements as defineDataPreviewer } from "json-data-viewer/loader";
import "@fortawesome/fontawesome-free/css/all.css";
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";

import Noir from "./presets/Noir.js";

import App from "./App.vue";
const app = createApp(App);
let host = window.location.host;
let protocol = window.location.protocol;
let hostname = window.location.hostname;
console.log("hostname", hostname);
console.log("host", host);
console.log("protocol", protocol);

if (hostname === "localhost" || host.includes("192.168.")) {
  host = hostname + ":8000";
}
if (host.includes("localcatalogfrontend")) {
  host = hostname.replace(/^localcatalogfrontend\./, "");
  app.config.globalProperties.$apiBase = `${protocol}//localcatalogbackend.${host}/validator-api`;
} else {
  app.config.globalProperties.$apiBase = `${protocol}//${host}/validator-api`;
}

//console.log("Backend api is: ", app.config.globalProperties.$apiBase);

console.log(
  "Backend is: ",
  "https://localcatalogbackend.idta.ds2.icelab.cloud/validator-api"
);

app.use(PrimeVue, {
  theme: {
    preset: Noir,
    options: {
      prefix: "p",
      darkModeSelector: ".p-dark",
      cssLayer: false,
    },
  },
});
app.use(defineDashButton);
app.use(ToastService);
app.use(defineDataPreviewer);
app.use(ConfirmationService);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
  },
});

app.mount("#app");
